import { ArrowUpRight, PenTool, Code2, LayoutGrid, Sparkles } from "lucide-react";
import { Reveal, scrollToId } from "./Reveal";
import { SERVICES } from "../lib/data";

const ICONS = { PenTool, Code2, LayoutGrid, Sparkles };

export const Services = () => {
  return (
    <section id="services" className="py-24 lg:py-32" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand mb-6">Services</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink max-w-3xl">
            Ways I can <span className="text-gradient">help you.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.title} delay={i * 0.08} className="h-full">
                <div className="group h-full glass rounded-3xl p-8 lg:p-10 hover:-translate-y-1 transition-transform duration-300 flex flex-col" data-testid={`service-card-${i}`}>
                  <div className="flex items-start justify-between mb-8">
                    <div className="w-14 h-14 rounded-2xl btn-gradient flex items-center justify-center shadow-lg shadow-brand/20">
                      <Icon className="w-6 h-6 text-white" strokeWidth={1.6} />
                    </div>
                    <span className="font-display font-extrabold text-3xl text-ink/10">0{i + 1}</span>
                  </div>
                  <h3 className="font-display font-semibold text-2xl text-ink mb-6">{s.title}</h3>
                  <dl className="space-y-4 text-sm flex-1">
                    <div>
                      <dt className="text-brand font-semibold uppercase tracking-wider text-[11px] mb-1">Who it&rsquo;s for</dt>
                      <dd className="text-ink-soft font-light leading-relaxed">{s.who}</dd>
                    </div>
                    <div>
                      <dt className="text-brand font-semibold uppercase tracking-wider text-[11px] mb-1">Problems it solves</dt>
                      <dd className="text-ink-soft font-light leading-relaxed">{s.solves}</dd>
                    </div>
                    <div>
                      <dt className="text-brand font-semibold uppercase tracking-wider text-[11px] mb-1">Expected outcome</dt>
                      <dd className="text-ink-soft font-light leading-relaxed">{s.outcome}</dd>
                    </div>
                  </dl>
                  <button onClick={() => scrollToId("contact")} className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-ink hover:text-brand transition-colors self-start" data-testid={`service-cta-${i}`}>
                    Request this service <ArrowUpRight className="w-4 h-4" />
                  </button>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
